import Image from 'next/image';
import iconPath from '~/module/assets/tg-star.png';

export function TgStarIcon(props: { className?: string }) {
  const size = 16;

  return <Image alt="telegram star" className={props.className} height={size} src={iconPath} width={size} />;
}

export function TgStarAmount(props: { amount: number | string }) {
  return (
    <div className="flex items-center">
      <div className="translate-y-[-1px] pr-[3px]">
        <TgStarIcon />
      </div>
      {props.amount}
    </div>
  );
}
